import React from 'react';
import './medical-form-footer.scss';
import { useTranslation } from 'react-i18next';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Col, FormFeedback, Input, Label, Row } from 'reactstrap';

type MedicalFormFooterPropsTypes = {
  form: UseFormReturn<any, object>;
};

export const MedicalFormFooter = (props: MedicalFormFooterPropsTypes) => {
  const { t } = useTranslation();

  const {
    control,
    getValues,
    formState: { errors },
  } = props.form;

  return (
    <div>
      <Row className="section-title">
        <Col md="12">
          <div>{t('MEDICAL_DECLARATION_FOOTER_TITLE')}</div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div className="medical-declaration-paragraph-explain">
            {t('MEDICAL_DECLARATION_FOOTER_1_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_2_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_3_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_4_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_5_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_6_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            {t('MEDICAL_DECLARATION_FOOTER_7_EXPLAIN')}
          </div>
        </Col>
        <Col md="12">
          <div className="medical-declaration-paragraph">
            <span> {t('MEDICAL_DECLARATION_FOOTER_8_SUB_EXPLAIN')}</span> <br />
            {t('MEDICAL_DECLARATION_FOOTER_8_EXPLAIN')}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="12" className="form-switches form-user-input">
          <div className="form-check form-check-inputs">
            <Label for="signature">
              {t('MEDICAL_DECLARATION_SIGNATURE_LABEL')}
            </Label>
            <Controller
              name="signature"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('FORM_ERRORS_FIELD_IS_REQUIRED'),
                },
              }}
              render={({ field }) => (
                // @ts-ignore
                <Input
                  checked={getValues().signature}
                  autoComplete="off"
                  id="signature"
                  type="checkbox"
                  invalid={errors.signature && true}
                  {...field}
                />
              )}
            />
            {errors.signature ? (
              <FormFeedback className="form-input-error">
                {errors.signature.message}
              </FormFeedback>
            ) : null}
          </div>
        </Col>
        <Col md="12" className="form-switches form-user-input">
          <div className="form-check form-check-inputs">
            <Label for="isAgreeTerms">
              {t('MEDICAL_DECLARATION_AGREE_TERMS_LABEL')}
              <a target="_blank" href={process.env.GYM_TERMS_FILE_URL}>
                {t('MEDICAL_DECLARATION_AGREE_TERMS_LINK_LABEL')}
              </a>
            </Label>
            <Controller
              name="isAgreeTerms"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('FORM_ERRORS_FIELD_IS_REQUIRED'),
                },
              }}
              render={({ field }) => (
                // @ts-ignore
                <Input
                  checked={getValues().isAgreeTerms}
                  autoComplete="off"
                  id="isAgreeTerms"
                  type="checkbox"
                  invalid={errors.isAgreeTerms && true}
                  {...field}
                />
              )}
            />
            {errors.isAgreeTerms ? (
              <FormFeedback className="form-input-error">
                {errors.isAgreeTerms.message}
              </FormFeedback>
            ) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
};
